"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = void 0;
const axios_class_1 = require("./axios.class");
class Utils {
    async uploadFile(file) {
        const formData = new FormData();
        formData.append('file', file);
        const { data } = await axios_class_1.axios.post(`v1/utils/saveFileToBucket`, formData, {
            headers: {
                contentType: 'multipart/form-data'
            }
        });
        return data;
    }
}
exports.utils = new Utils();
